import React from 'react';

const ChartEmptyState = ({
  title = 'No activity for this period',
  subtitle = 'Try changing the time filter.',
  compact = false,
  className = '',
}) => {
  const stateClassName = compact
    ? `chart-empty-state chart-empty-state-compact ${className}`.trim()
    : `chart-empty-state ${className}`.trim();

  return (
    <div className={stateClassName} role="status" aria-live="polite">
      <div className="chart-empty-content">
        {!compact && <div className="chart-empty-icon">i</div>}
        <div className="chart-empty-title">{title}</div>
        {!compact && subtitle ? <div className="chart-empty-subtitle">{subtitle}</div> : null}
      </div>
    </div>
  );
};

export default ChartEmptyState;
